import React, { useContext } from 'react';
import { THEMES } from '@americanexpress/consumer-travel-base';

const themeContext = React.createContext(THEMES.THEME_BLUE);

export const useThemeContext = () => useContext(themeContext);

export default themeContext;
